var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('file-uploader-vue',{attrs:{"fileAccept":_vm.fileAccept},on:{"onFileChange":_vm.handleFileChange}},[(!_vm.onlyUpload)?_vm._t("default"):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }